<template>
	<div>
		<b-tabs content-class="py-3" v-model="selected_tab" pills fill justified variant="bravoizq" nav-class="d-block d-md-flex">
			<b-tab title="DETALLE" active>
				<div>
					<showApartment :asset_id="asset_id" :key="asset_id" />
				</div>
			</b-tab>
			<b-tab title="PAGOS">
				<div>
					<payments :asset_id="asset_id" :key="asset_id" :project_id="project_id" />
				</div>
			</b-tab>
			<b-tab title="DOCUMENTOS">
				<div>
					<documents :asset_id="asset_id" :key="asset_id" />
				</div>
			</b-tab>
			<b-tab title="TARJETAS" v-if="true == false">
				<div>
					<users :asset_id="asset_id" :key="asset_id" />
				</div>
			</b-tab>
            <b-tab title="PAGOS AUTOMÁTICOS" v-if="checkPac">
                <PaymentOptions :asset_id="asset_id" :project_id="project_id" :key="asset_id" />
            </b-tab>
			<b-tab title="POSTVENTA" v-if="checkAftersale && haveAftersale">
				<div>
					<aftersale :asset-id="asset_id" :key="asset_id" :contract-id="apartment.contract_id" />
				</div>
			</b-tab>
		</b-tabs>
	</div>
</template>
<script>
import showApartment from "./ShowApartment";
import payments from "./payments/Payments";
import documents from "./documents/Documents";
import users from "./users/Users";
import PaymentOptions from "./paymentOptions";

export default {
	name: "options",
	components:{ showApartment, payments, documents, users, PaymentOptions },
	props: {
		asset_id: {default: null},
        project_id: {default: null},
		tab_index: {default: 0}
	},
	data() {
		return {
			selected_tab: this.tab_index
		}
	},
	methods: {
	},
	watch:{
		asset_id: {
			handler: function() {
				this.selected_tab = 0;
			}
		}
	},
	computed: {
		haveAftersale(){
			return this.$store.getters.getCustomerData ? (this.$store.getters.getCustomerData.products.find( product => product.name == "PostVenta") ? true : false) : false;
		},
		checkAftersale(){
			if(this.apartment && this.$store.state.haveAftersale){
				if(this.$store.state.haveAftersale.length > 0){
					if(this.$store.state.haveAftersale.find( elem => elem.id == this.apartment.project_id )){
					return this.$store.state.haveAftersale.find( elem => elem.id == this.apartment.project_id ).value.includes(this.apartment.asset_state) ? this.$store.state.haveAftersale.find( elem => elem.id == this.apartment.project_id ) : false;
					}else{
					return false;
					}
				}else{
					return false;
				}
			}else{
				return false;
			}
		},
		checkPac(){
			if(this.$store.getters.getCustomerData){
				let fintoc = this.$store.getters.getCustomerData.products.find( product => product.name == "Fintoc") ? true : false;
				let oneclick = false;
				if(this.customerId == 25){
				if(this.project_id == 3 || this.project_id == 9 ){
					oneclick = this.$store.getters.getCustomerData.products.find( product => product.name == "Pago One Click") ? true : false;
				}else{
					oneclick = false;
				}
				}else{
				oneclick = this.$store.getters.getCustomerData.products.find( product => product.name == "Pago One Click") ? true : false;
				}
				return fintoc || oneclick ? true : false;
			}else{
				return false;
			}
		}
	}
};
</script>
<style scoped>
</style> 